const feePaidToOptions = [
  { label: "Broker", value: "Broker" },
  { label: "BrokerAffiliate", value: "BrokerAffiliate" },
  { label: "Investor", value: "Investor" },
  { label: "Lender", value: "Lender" },
  { label: "LenderAffiliate", value: "LenderAffiliate" },
  { label: "Other", value: "Other" },
  { label: "ThirdPartyProvider", value: "ThirdPartyProvider" },
];

export default feePaidToOptions;
